import React from "react";
import Header from "../header2/Header";
import { motion } from "framer-motion";
import Slider from "react-slick";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import CustomerContext from "../blog-folder/CustomerContext";
import Seo from "../seo/Seo";
import Power from "./Power";

const Industries = () => {
  const { handleOpen } = React.useContext(CustomerContext);
  const settings3 = {
    infinite: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    cssEase: "linear",
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings7 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 4,
    speed: 500,
    nextArrow: <SampleNextArrow2 />,
    prevArrow: <SamplePrevArrow2 />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // Slider section start-----------------------------------------
  function SampleNextArrow2(props) {
    const { onClick } = props;
    return (
      <div className="slider-custome-button-next2" onClick={onClick}>
        <ArrowForwardIosIcon className="forword-arrow2" />
      </div>
    );
  }

  function SamplePrevArrow2(props) {
    const { onClick } = props;
    return (
      <div className="slider-custome-button-prev2" onClick={onClick}>
        <ArrowBackIosIcon className="backword-arrow2" />
      </div>
    );
  }

  const schema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "G-Rank",
        item: "https://www.grank.co.in/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Industries",
        item: "https://www.grank.co.in/industries",
      },
    ],
  };

  return (
    <>
      <Seo
        title="Digital Marketing For B2B & B2C Industries | G rank Digital"
        description="G-Rank Digital offers digital marketing services for many industries, working in both B2B and B2C markets. Check out how we can help your business grow here!"
        name="GRank"
        type="article"
        YahooSeeker="INDEX, FOLLOW"
        msnbot="INDEX, FOLLOW"
        googlebot="INDEX, FOLLOW"
        keywords="B2B Digital marketing agency, B2C Digital marketing agency"
        searchengines="ALL"
        canonical="https://www.grank.co.in/industries"
        schema={schema}
      ></Seo>

      <section className="section-top">
        <Header />
        {/* banner start */}
        <div className="organic-marketing-banner">
          <img
            className="img-fluid w-100 mobile-none"
            src="assest/photos/organicmarketing/organic-marketing-seo-banner.png"
            alt="G-Rank"
            title="industries"
          />
          <img
            className="img-fluid w-100 desktop-none"
            src="assest/photos/organicmarketing/organic-marketing-seo-banner-mobile2.png"
            alt="G-Rank"
            title="industries"
          />
          <div className="organic-marketing-banner-new-div">
            <motion.img
              className="img-fluid w-100"
              src="assest/photos/organicmarketing/organic-yellow-patch2.png"
              alt="G-Rank"
              title="industries"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
            />
            <h1 data-text="SearchEngine Optimization">Industries</h1>
            <h2>Industries We Serve</h2>

            <h3 onClick={handleOpen}>
              <NavLink to="">Explore</NavLink>
            </h3>
            <Breadcrumbs
              className="org-breadcru  breadcrumbs"
              aria-label="breadcrumb"
            >
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#000" : "#000",
                })}
                to="/"
              >
                <p>Home</p>
              </NavLink>
              <Typography color="#000">Industries</Typography>
            </Breadcrumbs>
          </div>
        </div>
        {/* banner end */}

        {/* seo service start */}
        <section className="organic-market-sem-service-section inds-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="org-mark-sem-text">
                  <motion.h4
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                  >
                    Industries We Serve
                  </motion.h4>
                </div>
              </div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/power.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/power-digital-marketing-agency">
                      Power Industry
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/power-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/hardware.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/hardware-digital-marketing-agency">
                      HardWare
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/hardware-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/healthcare.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/healthcare-digital-marketing-agency">
                      HealthCare
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/healthcare-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/automotive.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/automotive-digital-marketing-agency">
                      Automotive
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/automotive-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/tech.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/tech-digital-marketing-agency">Tech</NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/tech-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/manufacturing.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/manufacturing-digital-marketing-agency">
                      Manufacturing
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/manufacturing-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/rawmaterial.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/raw-material-digital-marketing-agency">
                      Raw Material
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/raw-material-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/realestate.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/realestate-digital-marketing-agency">
                      Real Estate
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/realestate-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/ecommerce.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/ecommerce-digital-marketing-agency">
                      E-Commerce
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/ecommerce-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/lifestyle.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/lifestyle-digital-marketing-agency">
                      Lifestyle
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/lifestyle-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/interiorfurniture.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/interior-furniture-digital-marketing-agency">
                      Interior Furniture
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/interior-furniture-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>

              <motion.div
                className="col-12 col-md-4 col-lg-4"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <motion.div
                  className="organic-market-service-div industries-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    className="img-fluid "
                    src="assest/photos/industries/education.png"
                    alt="G-Rank"
                    title="organic marketing"
                  />
                  <h4>
                    <NavLink to="/education-digital-marketing-agency">
                      Education
                    </NavLink>
                  </h4>
                </motion.div>
                <h4 className="organic-market-service-text ind-ser-txt">
                  A team of expert SEOs conducts keyword research according to
                  the niche industry and geographical location
                </h4>
                <p className="industries-ptext">
                  <NavLink to="/education-digital-marketing-agency">
                    View Resource
                  </NavLink>
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        {/* seo service end */}

        {/* action yellow start*/}
        <div className="action-yellow-div-text">
          <motion.p
            initial={{ opacity: 0, scale: 0, y: 100 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Want to Elevate Your Brand?
            <br /> Get in Touch with us Today
          </motion.p>
          <NavLink to="">
            <motion.p
              className="action-yellow-div-buttom"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              onClick={handleOpen}
            >
              Contact Us <ArrowRightAltIcon />
            </motion.p>
          </NavLink>
        </div>
        {/* action yellow end*/}

        {/* Quick Link section start */}
        <section>
          <div className="container-fluid">
            <div>
              <motion.h2
                className="branding-quick-link"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6 }}
              >
                Quick Links
                <p className="d-block"> For You</p>
              </motion.h2>
              <Slider {...settings3}>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/branding-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Branding</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/creative-content-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Creative & <p className="d-block"> Content</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/organic-marketing-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Organic <p className="d-block"> marketing</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/performance-marketing-company"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Performance <p className="d-block"> marketing</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/social-media-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Social Media</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/web-development-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Web <p className="d-block"> Development</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/domain"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Domain</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/hosting-service"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Web <p className="d-block"> Hosting</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/web-security-services"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Security</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/email-hosting-provider"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Email</h4>
                  </div>
                </NavLink>
              </Slider>
            </div>
          </div>
        </section>
        {/* Quick Link section end */}
        <img
          className="img-fluid w-100"
          src="assest/photos/branding/branding-footer-img.png"
          alt="G-Rank"
          title="organic marketing"
        />
      </section>
    </>
  );
};

export default Industries;
